
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkUser } from '../models/work-user';
import { WorkWegspesenDetails } from '../models/work-wegspesen-details';

export function getWegspesenDtoFormGroup() {
return new FormGroup({
    distanceFromHomeToWorkplace: new FormControl<number | undefined>(undefined, [Validators.required]),
    userId: new FormControl<number | undefined>(undefined, [Validators.required]),
    user: new FormControl<WorkUser | undefined>(undefined, [Validators.required]),
    kilometeresPaid: new FormControl<number | undefined>(undefined, [Validators.required]),
    kilometeresUnpaid: new FormControl<number | undefined>(undefined, [Validators.required]),
    timerecordIdsPaid: new FormControl<Array<number> | undefined>([], [Validators.required]),
    timerecordIdsUnpaid: new FormControl<Array<number> | undefined>([], [Validators.required]),
    details: new FormControl<WorkWegspesenDetails[]>([]),
})
;
}
      